import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {OrderApiService} from '../../../../core/services/order.api.service';
import {RouteService} from '../../../../core/services/route.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-cancel-delivery-modal',
  templateUrl: './cancel-delivery-modal.component.html',
  styleUrls: ['./cancel-delivery-modal.component.scss']
})
export class CancelDeliveryModalComponent implements OnInit {
  public successResponse: string;
  public errorResponse: string;
  @Input() transactionId: string;
  @Output() close = new EventEmitter<boolean>();

  constructor(
    private routeService: RouteService,
    private router: Router,
    private orderApiService: OrderApiService
  ) { }

  ngOnInit() {
  }

  public submit() {
    this.orderApiService.cancelDelivery(this.transactionId)
      .subscribe(() => {
        this.closeModal();
      }, (response) => {
        if (response && response.error && response.error.text) {
          this.successResponse = response.error.text;
        } else {
          this.errorResponse = response.error;
        }
      });
  }

  public cancel(): void {
    this.backToHomePage();
  }

  private backToHomePage(): void {
    const homePageUrl = this.routeService.getKyooTechPage();
    this.router.navigate([homePageUrl]).then(() => {
      window.location.reload();
    }).catch(error => console.log(error));
    
  }

  private closeModal(): void {
    this.close.emit();
  }
}
